<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("fnbDynamicPricing") }}</div>
      <router-link
        v-if="$can('create', 'F&B Dynamic Pricing')"
        class="btn-blue"
        to="add-fnb-dynamic-pricing"
        >{{ $t("add") }}</router-link
      >
    </div>

    <div
      v-if="selectedCinema.length != 0"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <div>
        <b-form-input
          v-debounce:300="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onSelect($event, cinema)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper mt-1">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >Cinema</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  href="#"
                  name="selectcine"
                  id="selectcine"
                  @click="onSelect($event, cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <!-- <span>{{ msgcinema }}</span> -->
            </p>
          </div>
        </div>
        <div
          v-if="dynamicPricingList.length > 0"
          class="col-md-8 d-flex justify-content-end align-items-center"
        >
          Download as:
          <img
            @click="excelDownload()"
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
          <!-- Download as: <img @click="ExportExcel()" class="mx-2" src="@/assets/img/icons/excel.svg" height="25" width="25" /> -->
        </div>
      </div>

      <table class="list-view-table">
        <thead class="text-center">
          <tr>
            <th class="text-left">
              <span class="pr-0">{{ $tc("status", 2) }}</span>
            </th>
            <th>{{ $t("id") }}</th>
            <th>
              <img
                v-if="this.columnName != 'fdp_name'"
                @click="onSortValue('fdp_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('fdp_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('fdp_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("fdpName") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'from_date_time'"
                @click="onSortValue('from_date_time', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('from_date_time', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('from_date_time', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("From Date") }}
            </th>
            <th>
              {{ $t("To Date") }}
            </th>
            <th>
              {{ $t("Time") }}
            </th>
            <th>
              {{ $t("Days") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'item_name'"
                @click="onSortValue('item_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('item_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('item_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("fnbitem") }}
            </th>
            <th>{{ $t("newItemPrice") }}</th>
          </tr>
        </thead>
        <tbody v-if="dynamicPricingList.length > 0">
          <tr v-for="(item, key) in dynamicPricingList" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.fdp_is_active === 'Y' ? 'active' : 'inactive'"
                />

                <i
                  v-if="$can('update', 'F&B Dynamic Pricing')"
                  class="edit-pen icon blue-icon cursor-pointer ml-1"
                  @click.prevent.stop="
                    goToRoute('/cinema-manager/edit-fnb-dynamic-pricing', item)
                  "
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>

                <i
                  class="icon-eye blue-icon cursor-pointer ml-1"
                  @click.prevent.stop="
                    goToRoute('/cinema-manager/view-fnb-dynamic-pricing', item)
                  "
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ item.fdp_common_id }}</td>
            <td>{{ item.fdp_name }}</td>
            <td>{{ moment(item.from_date_time).format("DD/MM/YYYY") }}</td>
            <td>{{ moment(item.to_date_time).format("DD/MM/YYYY") }}</td>
            <!-- <td>{{ item.to_date_time | fulldaydateparse }}</td> -->
            <!-- <td></td> -->
            <td>
              {{ moment(item.from_date_time).format("HH:mm") }} -
              {{ moment(item.to_date_time).format("HH:mm") }}
            </td>
            <td>
              {{
                [
                  item.fdp_is_sunday == "Y" ? "Su  " : "",
                  item.fdp_is_monday == "Y" ? "Mo  " : "",
                  item.fdp_is_tuesday == "Y" ? "Tu  " : "",
                  item.fdp_is_wednesday == "Y" ? "We  " : "",
                  item.fdp_is_thursday == "Y" ? "Th  " : "",
                  item.fdp_is_friday == "Y" ? "Fr  " : "",
                  item.fdp_is_saturday == "Y" ? "Sa  " : "",
                ]
                  .filter(Boolean)
                  .join(", ")
              }}
            </td>
            <td>{{ item.item_name }}</td>
            <td class="text-right">{{ item.fp_total_amount }}</td>
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    item.fdp_is_active === 'Y'
                      ? 'active'
                      : item.fdp_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-1">
                  <b-dropdown-item
                    v-if="$can('update', 'F&B Dynamic Pricing')"
                    @click="
                      goToRoute(
                        '/cinema-manager/edit-fnb-dynamic-pricing',
                        item
                      )
                    "
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      goToRoute(
                        '/cinema-manager/view-fnb-dynamic-pricing',
                        item
                      )
                    "
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import CinemaService from "@/services/CinemasService";
import moment from "moment";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import * as XLSX from "xlsx";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",
      searchCinema: "",
      selectedCinema: "",
      dynamicPricingList: [],
      dynamicPricingListExcel: [],
      isRoleID: true,
      Cinemas: [],
      CinemasCopy: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },

      debounce: null,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
    };
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    let obj = this.secureStore.get("USINFO").cinema_id;

    this.isRoleID = false;
    this.getCinemasList(obj);
    this.getviewingnumber();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectCinema = CinemaObj.cine_name;
      this.cinemaid = CinemaObj.cine_id;
      this.selectedCinema = CinemaObj.cine_name;
      this.getDynamicPricingList(CinemaObj.cine_id);
      this.getExceldynamicPricingList(CinemaObj.cine_id);
    }
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "FnBDynamicPricing" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "FnBDynamicPricing." + (type || "xlsx"));
    },
    excelDownload() {
      // this.getExceldynamicPricingList()
      let temp_data = this.dynamicPricingListExcel;

      this.dynamicPricingListExcel.forEach((x) => {
        x["cine_name"] = this.selectedCinema;
      });
      let dateparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };
      let fulldaydateparse = function (value) {
        if (!value) return "-";
        else
          return value
            ? moment(new Date(value)).format("MMMM Do YYYY, HH:mm")
            : "-";
      };
      let data = [
        {
          sheet: "Fnb Dynamic Pricing",

          columns: [
            {
              value: "cine_name",
              label: "Cinema Name",
            },

            {
              value: "fdp_common_id",
              label: "Id",
            },
            {
              value: (row) => row.fdp_name,
              label: "Pricing Name",
            },
            {
              value: (row) => moment(row.from_date_time).format("DD-MM-YYYY"),
              label: "From Date",
            },
            {
              value: (row) => moment(row.to_date_time).format("DD-MM-YYYY"),
              label: "To Date",
            },
            {
              value: (row) =>
                moment(row.from_date_time).format("HH:mm") +
                "-" +
                moment(row.to_date_time).format("HH:mm"),
              label: "Time",
            },
            {
              value: (row) =>
                [
                  row.fdp_is_sunday == "Y" ? "Su  " : "",
                  row.fdp_is_monday == "Y" ? "Mo  " : "",
                  row.fdp_is_tuesday == "Y" ? "Tu  " : "",
                  row.fdp_is_wednesday == "Y" ? "We  " : "",
                  row.fdp_is_thursday == "Y" ? "Th  " : "",
                  row.fdp_is_friday == "Y" ? "Fr  " : "",
                  row.fdp_is_saturday == "Y" ? "Sa  " : "",
                ]
                  .filter(Boolean)
                  .join(", "),
              label: "Days",
            },
            {
              value: "item_name",
              label: "F&B Item",
            },
            {
              value: (row) => +parseFloat(row.fp_total_amount),
              label: "New Item Net Price",
            },
            {
              value: (row) =>
                row.fdp_is_active == "Y" ? "Active" : "InActive",
              label: "Status",
            },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `FnbDynamicPricing${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    onSortValue(columnName, orderBy) {
      if (this.cinemaid == "") {
        return this.$toasted.show("Please select cinema");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getDynamicPricingList(this.cinemaid);
    },
    onSearch: function () {
      this.getDynamicPricingList(this.cinemaid);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSelect(event, cinema) {
      this.selectCinema = cinema.cine_name;
      this.cinemaid = cinema.cine_id;
      this.selectedCinema = cinema.cine_name;
      this.getDynamicPricingList(cinema.cine_id);
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getConcessionList;
      } else {
        this.currentPage = event;
        this.getDynamicPricingList(this.cinemaid);
      }
    },

    getExceldynamicPricingList(cine_id) {
      this.dynamicPricingListExcel = [];
      let payload = {
        limit: this.perPageExcel,
        currentPage: 1,
        searchValue: "",
        columnName: "",
        orderBy: "",
        cinema_id: cine_id,
      };
      ExhibitorService.GetAllFnbDynamicPricing(payload)
        .then((response) => {
          const { data } = response;
          if (data.Records.length) {
            this.dynamicPricingListExcel = data.Records;
          }
        })
        .catch(this._CatchError); //message
    },

    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getDynamicPricingList(cine_id) {
      this.dynamicPricingList = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: cine_id,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderBy,
      };
      ExhibitorService.GetAllFnbDynamicPricing(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.dynamicPricingList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          }
        })
        .catch(this._CatchError); //message

      this.getExceldynamicPricingList(cine_id);
    },
    goToRoute: function (path, item) {
      const { fdp_common_id } = item;
      this.$router.push({
        path: path,
        query: {
          fdp_common_id: fdp_common_id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FnbDynamicPricing/fnbDynamicPricing.vue